import { withInstall } from '@chenms-zj/utils/with-install'
import _Radio from './src/radio.vue'
import _RadioButton from './src/radio-button.vue'
import _RadioGroup from './src/radio-group.vue'

export const Radio = withInstall(_Radio)
export const RadioGroup = withInstall(_RadioGroup)
export const RadioButton = withInstall(_RadioButton)

export default Radio

export { radioProps } from './src/radio'
export { radioGroupProps } from './src/radio-group'
export { radioButtonProps } from './src/radio-button'

// 类型声明
declare module 'vue' {
  export interface GlobalComponents {
    'cms-radio': typeof Radio
    'cms-radioButton': typeof RadioButton
    'cms-radio-group': typeof RadioGroup
  }
}